import { NavLink, useLocation } from "react-router-dom";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from "@material-tailwind/react";
import { AiTwotoneShop } from "react-icons/ai";
import { BsCreditCard2FrontFill } from "react-icons/bs";
import { FaLock, FaReplyAll, FaPowerOff, FaWpforms } from "react-icons/fa";
import { GiOpenBook, GiHamburgerMenu } from "react-icons/gi";
import { HiTemplate } from "react-icons/hi";
import { IoMdChatbubbles, IoLogoWhatsapp, IoLogoBuffer } from "react-icons/io";
import {
  IoSettingsSharp,
  IoBook,
  IoQrCode,
  IoCartSharp,
} from "react-icons/io5";
import {
  MdMarkChatRead,
  MdPermContactCalendar,
  MdMonitorHeart,
  MdQuickreply,
  MdNotificationsActive,
  MdPayment,
  MdPayments,
  MdIntegrationInstructions,
} from "react-icons/md";
import { PiUsersFill, PiLinkBold } from "react-icons/pi";
import { RiMailSendFill, RiTimer2Fill } from "react-icons/ri";
import { TbPlugConnected } from "react-icons/tb";

import { useUserContext } from "../contexts/UserContextProvider";
import { useConversationContext } from "../contexts/ConversationContextProvider";
import { isFeatureAccessible } from "./utils/privacyCheck";
import appLogo from "../images/logo/logo-192px.png";

const Sidebar = ({ isSocketConnected }) => {
  const {
    currentUserInfo,
    isUserAdminOrSuperadmin,
    hideSidebar,
    apiCallLogout,
  } = useUserContext();
  const {
    messageNotificationCount,
    setMessageNotificationCount,
    isNewNotification,
  } = useConversationContext();

  const location = useLocation();

  // Dropdown menu component for reusability
  const DropdownMenu = ({ iconSize = "1.5rem" }) => (
    <MenuList className="bg-slate-800 border-slate-700 text-white z-50">
      {isUserAdminOrSuperadmin() && currentUserInfo?.pricingModel === 1 && (
        <MenuItem className="hover:bg-slate-700 text-white">
          <NavLink
            to="/dashboard/recharge"
            className={({ isActive }) =>
              `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
                isActive ? "text-blue-400" : "text-white hover:text-green-400"
              }`
            }
          >
            <MdPayment size={iconSize} />
            <p>Recharge</p>
          </NavLink>
        </MenuItem>
      )}

      {isUserAdminOrSuperadmin() && currentUserInfo?.pricingModel === 1 && (
        <MenuItem className="hover:bg-slate-700 text-white">
          <NavLink
            to="/dashboard/recharge-history"
            className={({ isActive }) =>
              `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
                isActive ? "text-blue-400" : "text-white hover:text-green-400"
              }`
            }
          >
            <MdPayments size={iconSize} />
            <p>Recharge History</p>
          </NavLink>
        </MenuItem>
      )}

      {isUserAdminOrSuperadmin() && (
        <MenuItem className="hover:bg-slate-700 text-white">
          <NavLink
            to="/dashboard/business-cards"
            className={({ isActive }) =>
              `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
                isActive ? "text-blue-400" : "text-white hover:text-green-400"
              }`
            }
          >
            <BsCreditCard2FrontFill size={iconSize} />
            <p>Business Cards</p>
          </NavLink>
        </MenuItem>
      )}

      <MenuItem className="hover:bg-slate-700 text-white">
        <NavLink
          to="/dashboard/wa-form-submissions"
          className={({ isActive }) =>
            `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
              isActive ? "text-blue-400" : "text-white hover:text-green-400"
            }`
          }
        >
          <FaWpforms size={iconSize} />
          <p>WA Forms Submissions</p>
        </NavLink>
      </MenuItem>

      <MenuItem className="hover:bg-slate-700 text-white">
        <NavLink
          to="/dashboard/order-details"
          className={({ isActive }) =>
            `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
              isActive ? "text-blue-400" : "text-white hover:text-green-400"
            }`
          }
        >
          <IoCartSharp size={iconSize} />
          <p>Order Details</p>
        </NavLink>
      </MenuItem>

      <MenuItem className="hover:bg-slate-700 text-white">
        <NavLink
          to="/dashboard/qr-generator"
          className={({ isActive }) =>
            `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
              isActive ? "text-blue-400" : "text-white hover:text-green-400"
            }`
          }
        >
          <IoQrCode size={iconSize} />
          <p>QR Generator</p>
        </NavLink>
      </MenuItem>

      {/* <MenuItem className="hover:bg-slate-700 text-white">
        <NavLink
          to="/dashboard/chatbots"
          className={({ isActive }) =>
            `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
              isActive ? "text-blue-400" : "text-white hover:text-green-400"
            }`
          }
        >
          <IoQrCode size={iconSize} />
          <p>Chatbots</p>
        </NavLink>
      </MenuItem> */}

      {isUserAdminOrSuperadmin() && (
        <MenuItem className="hover:bg-slate-700 text-white">
          <NavLink
            to="/dashboard/mylinks"
            className={({ isActive }) =>
              `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
                isActive ? "text-blue-400" : "text-white hover:text-green-400"
              }`
            }
          >
            <PiLinkBold size={iconSize} />
            <p>MyLinks</p>
          </NavLink>
        </MenuItem>
      )}

      {isUserAdminOrSuperadmin() && (
        <MenuItem className="hover:bg-slate-700 text-white">
          <NavLink
            to="/dashboard/app-integrations"
            className={({ isActive }) =>
              `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
                isActive ? "text-blue-400" : "text-white hover:text-green-400"
              }`
            }
          >
            <MdIntegrationInstructions size={iconSize} />
            <p>App Integrations</p>
          </NavLink>
        </MenuItem>
      )}

      {isUserAdminOrSuperadmin() && (
        <MenuItem className="hover:bg-slate-700 text-white">
          <NavLink
            to="/dashboard/activity-logs"
            className={({ isActive }) =>
              `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
                isActive ? "text-blue-400" : "text-white hover:text-green-400"
              }`
            }
          >
            <IoLogoBuffer size={iconSize} />
            <p>Activity Logs</p>
          </NavLink>
        </MenuItem>
      )}

      {isUserAdminOrSuperadmin() && currentUserInfo?.pricingModel === 0 && (
        <MenuItem className="hover:bg-slate-700 text-white">
          <NavLink
            to="/dashboard/subscriptions"
            className={({ isActive }) =>
              `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
                isActive ? "text-blue-400" : "text-white hover:text-green-400"
              }`
            }
          >
            <MdPayments size={iconSize} />
            <p>Subscriptions</p>
          </NavLink>
        </MenuItem>
      )}

      <MenuItem className="hover:bg-slate-700 text-white">
        <NavLink
          to="/faq"
          className={({ isActive }) =>
            `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
              isActive ? "text-blue-400" : "text-white hover:text-green-400"
            }`
          }
        >
          <IoBook size={iconSize} />
          <p>FAQs</p>
        </NavLink>
      </MenuItem>

      <MenuItem className="hover:bg-slate-700 text-white">
        <NavLink
          to="/dashboard/settings"
          className={({ isActive }) =>
            `transition-colors duration-200 w-full inline-flex items-center gap-3 ${
              isActive ? "text-blue-400" : "text-white hover:text-green-400"
            }`
          }
        >
          <IoSettingsSharp size={iconSize} />
          <p>Settings</p>
        </NavLink>
      </MenuItem>

      <hr className="my-3 border-slate-600" />

      <MenuItem className="hover:bg-slate-700 text-white">
        <button
          onClick={apiCallLogout}
          className="transition-colors duration-200 w-full inline-flex items-center gap-3 text-red-400 hover:text-red-300"
        >
          <FaPowerOff size={iconSize} />
          <p>Log Out</p>
        </button>
      </MenuItem>
    </MenuList>
  );

  return (
    <div className="bg-slate-900 text-white">
      {/* MOBILE SIDEBAR */}
      <div className="md:hidden">
        {/* Mobile Header - Top aligned on mobile */}
        <div className="w-full px-4 py-3 flex items-center justify-between border-b border-slate-700">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <img src={appLogo} className="w-10 h-10" alt="WaBM WA API" />
          </div>

          {/* Mobile Controls */}
          <div className="flex items-center gap-4">
            <TbPlugConnected
              title={`Message receiver ${
                isSocketConnected ? "connected" : "disconnected"
              }`}
              size="1.2rem"
              className={isSocketConnected ? "text-green-500" : "text-red-600"}
            />

            <NavLink
              to="/dashboard/notifications"
              title={`${
                isNewNotification &&
                location?.pathname !== "/dashboard/notifications"
                  ? "New Notifications"
                  : "Notifications"
              }`}
              className={({ isActive }) =>
                `transition-colors duration-200 ${
                  isNewNotification &&
                  location?.pathname !== "/dashboard/notifications"
                    ? "text-amber-300"
                    : isActive
                    ? "text-blue-400"
                    : "hover:text-blue-400"
                }`
              }
            >
              <MdNotificationsActive size="1.2rem" />
            </NavLink>

            <Menu placement="bottom-right">
              <MenuHandler className="transition-colors duration-200 cursor-pointer hover:text-blue-400">
                <GiHamburgerMenu size="1.2rem" />
              </MenuHandler>
              <DropdownMenu iconSize="1.2rem" />
            </Menu>
          </div>
        </div>

        {/* Mobile Navigation - Horizontal scroll */}
        <div className="overflow-x-auto scrollbar-hide">
          <div className="flex gap-2 p-3 min-w-max">
            <NavLink
              to="/dashboard/overview"
              className={({ isActive }) =>
                `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                }`
              }
            >
              <AiTwotoneShop size="1.1rem" />
              <span>Overview</span>
            </NavLink>

            <NavLink
              to="/dashboard/chats"
              className={({ isActive }) =>
                `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 relative ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                }`
              }
              onClick={() => setMessageNotificationCount(0)}
            >
              <IoMdChatbubbles size="1.1rem" />
              <span>Chats</span>
              {messageNotificationCount > 0 &&
                location?.pathname !== "/dashboard/chats" && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                    {messageNotificationCount}
                  </span>
                )}
              {!isFeatureAccessible(currentUserInfo) && (
                <FaLock size="0.7rem" className="opacity-70" />
              )}
            </NavLink>

            <NavLink
              to="/dashboard/templates"
              className={({ isActive }) =>
                `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                }`
              }
            >
              <HiTemplate size="1.1rem" />
              <span>Templates</span>
            </NavLink>

            {isUserAdminOrSuperadmin() && (
              <NavLink
                to="/dashboard/contacts"
                className={({ isActive }) =>
                  `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? "bg-blue-600 text-white shadow-lg"
                      : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                  }`
                }
              >
                <MdPermContactCalendar size="1.1rem" />
                <span>Contacts</span>
              </NavLink>
            )}

            <NavLink
              to="/dashboard/campaign"
              className={({ isActive }) =>
                `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                }`
              }
            >
              <RiMailSendFill size="1.1rem" />
              <span>Campaign</span>
              {!isFeatureAccessible(currentUserInfo) && (
                <FaLock size="0.7rem" className="opacity-70" />
              )}
            </NavLink>

            <NavLink
              to="/dashboard/monitor"
              className={({ isActive }) =>
                `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                }`
              }
            >
              <MdMonitorHeart size="1.1rem" />
              <span>Monitor</span>
            </NavLink>

            {currentUserInfo?.catalogId &&
              currentUserInfo?.catalogId !== "" && (
                <NavLink
                  to="/dashboard/catalog"
                  className={({ isActive }) =>
                    `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 ${
                      isActive
                        ? "bg-blue-600 text-white shadow-lg"
                        : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                    }`
                  }
                >
                  <GiOpenBook size="1.1rem" />
                  <span>Catalog</span>
                  {!isFeatureAccessible(currentUserInfo) && (
                    <FaLock size="0.7rem" className="opacity-70" />
                  )}
                </NavLink>
              )}

            {isUserAdminOrSuperadmin() && (
              <NavLink
                to="/dashboard/agents"
                className={({ isActive }) =>
                  `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? "bg-blue-600 text-white shadow-lg"
                      : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                  }`
                }
              >
                <PiUsersFill size="1.1rem" />
                <span>Agents</span>
                {!isFeatureAccessible(currentUserInfo) && (
                  <FaLock size="0.7rem" className="opacity-70" />
                )}
              </NavLink>
            )}

            {isUserAdminOrSuperadmin() && (
              <NavLink
                to="/dashboard/auto-replies"
                className={({ isActive }) =>
                  `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? "bg-blue-600 text-white shadow-lg"
                      : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                  }`
                }
              >
                <FaReplyAll size="1.1rem" />
                <span>Auto Replies</span>
                {!isFeatureAccessible(currentUserInfo) && (
                  <FaLock size="0.7rem" className="opacity-70" />
                )}
              </NavLink>
            )}

            {isUserAdminOrSuperadmin() && (
              <NavLink
                to="/dashboard/follow-ups"
                className={({ isActive }) =>
                  `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? "bg-blue-600 text-white shadow-lg"
                      : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                  }`
                }
              >
                <RiTimer2Fill size="1.1rem" />
                <span>Follow-Ups</span>
                {!isFeatureAccessible(currentUserInfo) && (
                  <FaLock size="0.7rem" className="opacity-70" />
                )}
              </NavLink>
            )}

            {isUserAdminOrSuperadmin() && (
              <NavLink
                to="/dashboard/assigned-chats"
                className={({ isActive }) =>
                  `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? "bg-blue-600 text-white shadow-lg"
                      : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                  }`
                }
              >
                <MdMarkChatRead size="1.1rem" />
                <span>Assigned Chats</span>
              </NavLink>
            )}

            <NavLink
              to="/dashboard/quick-reply"
              className={({ isActive }) =>
                `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                }`
              }
            >
              <MdQuickreply size="1.1rem" />
              <span>Quick Reply</span>
            </NavLink>

            <NavLink
              to="/dashboard/whatsapp-manager"
              className={({ isActive }) =>
                `flex-shrink-0 px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
                }`
              }
            >
              <IoLogoWhatsapp size="1.1rem" />
              <span>WhatsApp Manager</span>
            </NavLink>
          </div>
        </div>
      </div>

      {/* DESKTOP SIDEBAR */}
      <div className="hidden md:flex md:flex-col md:min-h-screen md:min-w-full">
        {/* Desktop Header */}
        <div className="flex flex-col items-center gap-3 p-4 border-b border-slate-700">
          <img src={appLogo} className="w-16 h-16" alt="WaBM WA API" />

          <div className="flex items-center gap-4">
            <TbPlugConnected
              title={`Message receiver ${
                isSocketConnected ? "connected" : "disconnected"
              }`}
              size="1.5rem"
              className={isSocketConnected ? "text-green-500" : "text-red-600"}
            />

            <NavLink
              to="/dashboard/notifications"
              title={`${
                isNewNotification &&
                location?.pathname !== "/dashboard/notifications"
                  ? "New Notifications"
                  : "Notifications"
              }`}
              className={({ isActive }) =>
                `transition-colors duration-200 ${
                  isNewNotification &&
                  location?.pathname !== "/dashboard/notifications"
                    ? "text-amber-300"
                    : isActive
                    ? "text-blue-400"
                    : "hover:text-blue-400"
                }`
              }
            >
              <MdNotificationsActive size="1.5rem" />
            </NavLink>

            <Menu placement="bottom-right">
              <MenuHandler className="transition-colors duration-200 cursor-pointer hover:text-blue-400">
                <GiHamburgerMenu size="1.5rem" />
              </MenuHandler>
              <DropdownMenu iconSize="1.5rem" />
            </Menu>
          </div>
        </div>

        {/* Desktop Navigation */}
        <div className="flex-1 pb-4 overflow-y-auto">
          <div className="space-y-1 px-2">
            <NavLink
              to="/dashboard/overview"
              title={hideSidebar ? "Overview" : ""}
              className={({ isActive }) =>
                `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 border-b border-slate-600 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "text-slate-300 hover:bg-slate-800 hover:text-white"
                }`
              }
            >
              <AiTwotoneShop size="1.4rem" />
              {!hideSidebar && <span>Overview</span>}
            </NavLink>

            <NavLink
              to="/dashboard/chats"
              title={hideSidebar ? "Chats" : ""}
              className={({ isActive }) =>
                `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 relative border-b border-slate-600 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "text-slate-300 hover:bg-slate-800 hover:text-white"
                }`
              }
              onClick={() => setMessageNotificationCount(0)}
            >
              <IoMdChatbubbles size="1.4rem" />
              {!hideSidebar && <span>Chats</span>}
              {messageNotificationCount > 0 &&
                location?.pathname !== "/dashboard/chats" && (
                  <span className="absolute right-2 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
                    {messageNotificationCount}
                  </span>
                )}
              {!isFeatureAccessible(currentUserInfo) && (
                <FaLock size={10} className="opacity-70" />
              )}
            </NavLink>

            <NavLink
              to="/dashboard/templates"
              title={hideSidebar ? "Templates" : ""}
              className={({ isActive }) =>
                `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 border-b border-slate-600 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "text-slate-300 hover:bg-slate-800 hover:text-white"
                }`
              }
            >
              <HiTemplate size="1.4rem" />
              {!hideSidebar && <span>Templates</span>}
            </NavLink>

            {isUserAdminOrSuperadmin() && (
              <NavLink
                to="/dashboard/contacts"
                title={hideSidebar ? "Contacts" : ""}
                className={({ isActive }) =>
                  `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 border-b border-slate-600 ${
                    isActive
                      ? "bg-blue-600 text-white shadow-lg"
                      : "text-slate-300 hover:bg-slate-800 hover:text-white"
                  }`
                }
              >
                <MdPermContactCalendar size="1.4rem" />
                {!hideSidebar && <span>Contacts</span>}
              </NavLink>
            )}

            <NavLink
              to="/dashboard/campaign"
              title={hideSidebar ? "Campaign" : ""}
              className={({ isActive }) =>
                `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 border-b border-slate-600 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "text-slate-300 hover:bg-slate-800 hover:text-white"
                }`
              }
            >
              <RiMailSendFill size="1.4rem" />
              {!hideSidebar && <span>Campaign</span>}
              {!isFeatureAccessible(currentUserInfo) && (
                <FaLock size={10} className="opacity-70" />
              )}
            </NavLink>

            <NavLink
              to="/dashboard/monitor"
              title={hideSidebar ? "Monitor Metrics" : ""}
              className={({ isActive }) =>
                `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 border-b border-slate-600 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "text-slate-300 hover:bg-slate-800 hover:text-white"
                }`
              }
            >
              <MdMonitorHeart size="1.4rem" />
              {!hideSidebar && <span>Monitor</span>}
            </NavLink>

            {currentUserInfo?.catalogId &&
              currentUserInfo?.catalogId !== "" && (
                <NavLink
                  to="/dashboard/catalog"
                  title={hideSidebar ? "Catalog" : ""}
                  className={({ isActive }) =>
                    `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 border-b border-slate-600 ${
                      isActive
                        ? "bg-blue-600 text-white shadow-lg"
                        : "text-slate-300 hover:bg-slate-800 hover:text-white"
                    }`
                  }
                >
                  <GiOpenBook size="1.4rem" />
                  {!hideSidebar && <span>Catalog</span>}
                  {!isFeatureAccessible(currentUserInfo) && (
                    <FaLock size={10} className="opacity-70" />
                  )}
                </NavLink>
              )}

            {isUserAdminOrSuperadmin() && (
              <NavLink
                to="/dashboard/agents"
                title={hideSidebar ? "Agents" : ""}
                className={({ isActive }) =>
                  `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 border-b border-slate-600 ${
                    isActive
                      ? "bg-blue-600 text-white shadow-lg"
                      : "text-slate-300 hover:bg-slate-800 hover:text-white"
                  }`
                }
              >
                <PiUsersFill size="1.4rem" />
                {!hideSidebar && <span>Agents</span>}
                {!isFeatureAccessible(currentUserInfo) && (
                  <FaLock size={10} className="opacity-70" />
                )}
              </NavLink>
            )}

            {isUserAdminOrSuperadmin() && (
              <NavLink
                to="/dashboard/auto-replies"
                title={hideSidebar ? "Auto Replies" : ""}
                className={({ isActive }) =>
                  `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 border-b border-slate-600 ${
                    isActive
                      ? "bg-blue-600 text-white shadow-lg"
                      : "text-slate-300 hover:bg-slate-800 hover:text-white"
                  }`
                }
              >
                <FaReplyAll size="1.4rem" />
                {!hideSidebar && <span>Auto Replies</span>}
                {!isFeatureAccessible(currentUserInfo) && (
                  <FaLock size={10} className="opacity-70" />
                )}
              </NavLink>
            )}

            {isUserAdminOrSuperadmin() && (
              <NavLink
                to="/dashboard/follow-ups"
                title={hideSidebar ? "Follow-Ups" : ""}
                className={({ isActive }) =>
                  `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 border-b border-slate-600 ${
                    isActive
                      ? "bg-blue-600 text-white shadow-lg"
                      : "text-slate-300 hover:bg-slate-800 hover:text-white"
                  }`
                }
              >
                <RiTimer2Fill size="1.4rem" />
                {!hideSidebar && <span>Follow-Ups</span>}
                {!isFeatureAccessible(currentUserInfo) && (
                  <FaLock size={10} className="opacity-70" />
                )}
              </NavLink>
            )}

            {isUserAdminOrSuperadmin() && (
              <NavLink
                to="/dashboard/assigned-chats"
                title={hideSidebar ? "Assigned Chats" : ""}
                className={({ isActive }) =>
                  `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 border-b border-slate-600 ${
                    isActive
                      ? "bg-blue-600 text-white shadow-lg"
                      : "text-slate-300 hover:bg-slate-800 hover:text-white"
                  }`
                }
              >
                <MdMarkChatRead size="1.4rem" />
                {!hideSidebar && <span>Assigned Chats</span>}
              </NavLink>
            )}

            <NavLink
              to="/dashboard/quick-reply"
              title={hideSidebar ? "Quick Reply" : ""}
              className={({ isActive }) =>
                `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 border-b border-slate-600 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "text-slate-300 hover:bg-slate-800 hover:text-white"
                }`
              }
            >
              <MdQuickreply size="1.4rem" />
              {!hideSidebar && <span>Quick Reply</span>}
            </NavLink>

            <NavLink
              to="/dashboard/whatsapp-manager"
              title={hideSidebar ? "Whatsapp Manager" : ""}
              className={({ isActive }) =>
                `w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 border-b border-slate-600 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg"
                    : "text-slate-300 hover:bg-slate-800 hover:text-white"
                }`
              }
            >
              <IoLogoWhatsapp size="1.4rem" />
              {!hideSidebar && (
                <span className="whitespace-nowrap">Whatsapp Manager</span>
              )}
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
